import HeroSection from './components/HeroSection'
import BossSection from './components/BossSection'
import MethodSection from './components/MethodSection'
import PricingSection from './components/PricingSection'
import AnalysisSection from './components/AnalysisSection'
import FinalSection from './components/FinalSection'
import Footer from './components/Footer'

export default function App() {
  return (
    <div className="relative min-h-screen" style={{ background: '#050510' }}>
      <HeroSection />
      <BossSection />
      <MethodSection />
      <PricingSection />
      <AnalysisSection />
      <FinalSection />
      <Footer />
    </div>
  )
}
